import React from 'react'
import ReactDOM from "react-dom"
import NavigationMenu_TopHeader from "../../components/top-header/top-header"
import NavigationSection from "../../../../core/model2/navigation/navigation-section"
import {NavigationSectionType} from "../../../../core/model2/navigation/@const"
import {MenuComponentProps} from "../const";
import VScroll from "../../../../core/gd-components/scrolling/custom-v-scroll/v-scroll";
import {BUS_TREE_CHANGE} from "../../../../core/gd/bus/bus-event-type"
import NavigationMenu_ToolsContent from "./menu-content";

// const debug = "MainMenu_Tools"
const debug = false

export default class MainMenu_Tools extends React.Component<MenuComponentProps> {

    private animationDelay  : any
    private animShow        : boolean = false

    public navigationSection : NavigationSection    = gd.navigationStructure.get(NavigationSectionType.TOOLS)

    constructor(props:MenuComponentProps) {
        super(props);
    }

    componentDidMount() {
        //needed for animation
        this.animationDelay = _.delay(()=>{
            this.animShow = true
            const dom = ReactDOM.findDOMNode(this);
            gd.utils.Dom.addClass(dom, 'anim-show');
        }, 50);

        gd.bus.subscribe(BUS_TREE_CHANGE, this, this.onTreeChange)
    }

    componentWillUnmount() {
        clearTimeout(this.animationDelay)

        gd.bus.unsubscribe(this)
    }

    onTreeChange = () => {
        debug && console.log(debug, 'onTreeChange')

        this.forceUpdate()
    }

    render() {
        const classes = Classes('main-menu-container menu-tools ui5-menu hovered',{
            'animation': gd.layout.shouldAnimateMenu && !this.props.noAnimation,
            'anim-show': this.animShow
        });

        // const showCrmMenu = gd.modules.crm.enabled;

        return (
            <div className={classes}>

                <NavigationMenu_TopHeader space={gd.spaces.tools} />

                <VScroll ref={this.props.refScroll} className="main-menu-scroll" mutationObserverEnabled={true}>

                    <NavigationMenu_ToolsContent {...this.props} />

                </VScroll>

            </div>
        );
    }
}
